import { render, staticRenderFns } from "./EDrawerHistoricoPlanoLancado.vue?vue&type=template&id=1954ba08&scoped=true"
import script from "./EDrawerHistoricoPlanoLancado.vue?vue&type=script&lang=js"
export * from "./EDrawerHistoricoPlanoLancado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1954ba08",
  null
  
)

export default component.exports